<template>

  <div class="index">
    <div class="poster-img">
      <el-image role="text" aria-label="一二三，无障爱专属海报" class="poster-img-img" :src="img"></el-image>
    </div>
    <div>
      <vue-canvas-poster :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    </div>

    <p tabindex="1" id="title-p" role="text" aria-label="长按上方图片保存至相册，欢迎分享至社群朋友圈，一起传递无障爱。">
      <el-image  class="title-img"
                src="/static/image/poster/文字.png?v=1"></el-image>
    </p>
    <div class="start">
      <el-button aria-label="返回" type="primary" @click="come_back()">
      </el-button>
    </div>
  </div>
</template>

<script>

import {VueCanvasPoster} from 'vue-canvas-poster'
import Common from "../utils/Common";


export default {
  name: "poster",
  data() {
    return {
      painting: {
        width: '750px',
        height: '1333px',
        // background: '#fff',
        views: [
          {
            type: 'image',
            url: require("../../../static/image/poster/" + localStorage.getItem("story") + ".png"),
            // url: require("../../../static/image/poster/0.png"),
            css: {
              width: '750px',
              height: '1333px',
            }
          },
          {
            type: 'image',
            url: Common.headimgurl,
            // url:"https://www.sunniejs.cn/static/avatar.png",
            css: {
              top: '200px',
              left: '115px',
              borderRadius: '100%',
              width: '120px',
              height: '120px',
              borderWidth: '6px',
              borderColor: '#f5f5f5'
            }
          },
          {
            type: 'text',
            text: Common.nickname,
            // text:"富贵Rich富贵Rich富贵Rich富贵Rich",
            css: {
              top: '350px',
              left: '115px',
              width: '350px',
              maxLines: 1,
              fontSize: '24px',
              fontWeight: '500'
            }
          },

        ],
      },
      img: '',
    }
  },
  mounted() {
    this.$nextTick(function () {
      document.getElementById('title-p').focus()
    })
  },
  methods: {
    success(src) {
      this.img = src
    },
    fail(err) {
      console.log('fail', err)
    },
    come_back() {

      this.$router.replace('/match_result')


    }

  },
  components: {
    VueCanvasPoster,
  },
}
</script>

<style scoped>

.index {
  height: auto;
  background-image: url("/static/image/poster/BG.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}


.start {
  text-align: center; /*水平居中*/
  /*margin-top: -20px;*/
  /*margin-top: 20%;*/
}

.el-button {
  width: 100px;
  height: 35px;
  margin-top: 20px;
  margin-bottom: 40px;
  background: url("/static/image/poster/返回.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  border: none;
}


.title-img {
  margin-top: 30px;
  /*pointer-events: none;*/
}


.poster-img {
  width: 100%;
}

.poster-img-img {
  width: 90%;
  left: 5%;
  box-shadow: 5px 5px 5px #ededed;
}

/*去掉获得焦点的边框*/
p {
  outline: none;
}

</style>



// WEBPACK FOOTER //
// src/components/home/poster.vue